import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { CSSProperties, FC, ReactNode } from 'react';
import { WbCardContent } from '../WbCard';

type WbDrawerContentProps = {
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
};

const useStyles = makeStyles(
  theme => ({
    root: {
      overflow: 'auto',
      flex: 1,
      [theme.breakpoints.down('sm')]: {
        flex: 'auto',
        overflow: 'visible',
      },
    },
  }),
  { name: 'WbDrawerContent' },
);

export const WbDrawerContent: FC<WbDrawerContentProps> = ({
  className,
  style,
  children,
}) => {
  const classes = useStyles();
  return (
    <WbCardContent className={clsx(classes.root, className)} style={style}>
      {children}
    </WbCardContent>
  );
};
